var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Model, { attr, belongsTo } from '@ember-data/model';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

export let IntegrationMetaKey = /*#__PURE__*/function (IntegrationMetaKey) {
  IntegrationMetaKey["GOOGLE_MERCHANT_CENTER_ACCOUNT_INFO"] = "GOOGLE_MERCHANT_CENTER_ACCOUNT_INFO";
  IntegrationMetaKey["META_COMMERCE_ACCOUNT_INFO"] = "META_COMMERCE_ACCOUNT_INFO";
  IntegrationMetaKey["GOOGLE_ADS_ACCOUNT_INFO"] = "GOOGLE_ADS_ACCOUNT_INFO";
  IntegrationMetaKey["DOORDASH_ACCOUNT_INFO"] = "DOORDASH_ACCOUNT_INFO";
  return IntegrationMetaKey;
}({});
let IntegrationMeta = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('json-or-value'), _dec4 = attr('date'), _dec5 = attr('date'), _dec6 = belongsTo('channels/integration'), (_class = class IntegrationMeta extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "key", _descriptor2, this);
    _initializerDefineProperty(this, "value", _descriptor3, this);
    _initializerDefineProperty(this, "createdAt", _descriptor4, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor5, this);
    _initializerDefineProperty(this, "integration", _descriptor6, this);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "key", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "value", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "integration", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { IntegrationMeta as default };